import { Checkbox } from '@/components/ui/checkbox'
import { FilterSection } from './FilterSection'
import { ArrowBigUpDash } from 'lucide-react'

interface FilterSectionCreatedByProps {
  value: string
  onChange: (value: '' | 'AGENT' | 'PLATFORM') => void
}

export function FilterSectionCreatedBy({ value, onChange }: FilterSectionCreatedByProps) {
  return (
    <FilterSection icon={ArrowBigUpDash} label="Enviado por">
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="created-by-agent"
            checked={value === 'AGENT'}
            onCheckedChange={(checked) => onChange(checked ? 'AGENT' : '')}
          />
          <label htmlFor="created-by-agent" className="text-sm cursor-pointer">
            Agent
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="created-by-platform"
            checked={value === 'PLATFORM'}
            onCheckedChange={(checked) => onChange(checked ? 'PLATFORM' : '')}
          />
          <label htmlFor="created-by-platform" className="text-sm cursor-pointer">
            Platform
          </label>
        </div>
      </div>
    </FilterSection>
  )
}
